//@ts-nocheck

import React from 'react'

import { Heading, Paragraph } from '../../../atoms/Typography/Typography.component'
import { Col, Row, SpacerBase } from '../../../atoms/GridSystem'
import Button from '../../../atoms/Button/Button.component'
import ItemsGrouped from '../../../molecules/ItemsGrouped/ItemsGrouped.component'

import * as S from '../Text.styles'

interface TextRichTextProps {
  sectionTitle?: {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    typo: string
    content: string
  }
  subtitle?: {
    as: 'p'
    typo: string
    content: string
  }
  body?: Array<{
    id?: string | number
    title?: string
    body?: string
  }>
  ctaPrimary?: {
    label: string
    [key: string]: any
  }
  ctaSecondary?: {
    label: string
    [key: string]: any
  }
}

const TextRichText: React.FC<TextRichTextProps> = ({ sectionTitle, subtitle, body: bodyArr, ctaPrimary, ctaSecondary }) => {
  return (
    <Row>
      <Col xs={12} md={5} $direction="column" offsetRight={{ xs: 0, md: 1 }}>
        {sectionTitle ? (
          <>
            <Heading as={sectionTitle.as} typo={sectionTitle.typo}>
              {sectionTitle.content}
            </Heading>
            <SpacerBase xs={1} />
          </>
        ) : null}
      </Col>
      <Col xs={12} md={6} $direction="column" align="flex-start">
        {subtitle ? (
          <>
            <Paragraph {...subtitle} />
            <SpacerBase xs={5} />
          </>
        ) : null}
        {bodyArr && bodyArr.length > 0
          ? bodyArr.map(({ id, title, body }, i) => (
              <div key={id ? id : i}>
                {title ? (
                  <>
                    <Paragraph as="div" typo="headingSM">
                      {title}
                    </Paragraph>
                    <SpacerBase xs={1} />
                  </>
                ) : null}
                {body ? (
                  <Paragraph as="div" typo="paragraphMD">
                    {body}
                  </Paragraph>
                ) : null}
                {i + 1 < bodyArr.length ? <SpacerBase xs={5} /> : null}
              </div>
            ))
          : null}
        {ctaPrimary || ctaSecondary ? (
          <>
            <SpacerBase xs={4} />
            <ItemsGrouped direction={{ xs: "column", lg: "row" }} space={{ xs: 16, lg: 24 }} fullWidth={['xs', 'sm', 'md']}>
              {ctaPrimary ? <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" /> : null}
              {ctaSecondary ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" /> : null}
            </ItemsGrouped>
          </>
        ) : null}
      </Col>
    </Row>
  )
}

export default TextRichText
